"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKSPACE_PERMISSION_GRAPH_ADVANCED_EVENT = exports.WORKSPACE_PERMISSION_CHANGE_TYPES = void 0;
exports.isNonEmptyString = isNonEmptyString;
exports.isSignedPermissionSnapshotGrant = isSignedPermissionSnapshotGrant;
function isNonEmptyString(value) {
    return typeof value === 'string' && value.length > 0;
}
function isSignedPermissionSnapshotGrant(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const grant = value;
    const provenance = grant.provenance;
    return (isNonEmptyString(grant.resourceId) &&
        (grant.resourceType === 'doc' || grant.resourceType === 'folder') &&
        Array.isArray(grant.allowedActions) &&
        grant.allowedActions.every(action => typeof action === 'string' &&
            (action.startsWith('Doc_') || action.startsWith('Folder_'))) &&
        typeof provenance === 'object' &&
        provenance !== null &&
        isNonEmptyString(provenance.sourceType) &&
        isNonEmptyString(provenance.sourceId) &&
        typeof provenance.inherited === 'boolean' &&
        typeof provenance.effective === 'boolean' &&
        typeof provenance.directOverridePresent === 'boolean');
}
exports.WORKSPACE_PERMISSION_CHANGE_TYPES = [
    'doc_role_granted',
    'doc_role_updated',
    'doc_role_revoked',
    'folder_role_granted',
    'folder_role_revoked',
    'area_role_granted',
    'area_role_revoked',
    'folder_metadata_updated',
    'folder_inheritance_changed',
    'folder_visibility_changed',
    'folder_moved',
    'folder_created',
    'doc_created',
    'doc_moved',
    'workspace_member_joined',
    'workspace_member_role_changed',
    'workspace_member_revoked',
    'workspace_member_left',
];
exports.WORKSPACE_PERMISSION_GRAPH_ADVANCED_EVENT = 'workspace:permission-graph-advanced';
//# sourceMappingURL=contract.js.map